import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/targeting')({
  component: TargetingLayout,
});

function TargetingLayout() {
  return <Outlet />;
}
